import styled from "styled-components";

export const Navigation = styled.nav`
  ${({ fontWeight = "700" }) => fontWeight && { fontWeight }}
`;

Navigation.displayName = "Navigation";
